<template>
  <div class="right-box" :style="{ right: right + 'px'}">
    <div class="top">
      <div class="title-box">
        <span class="title-g"></span>
        <!-- <img src="/static/img/home/title.png" alt=""> -->
        <span>近期告警信息统计</span>
      </div>
      <div ref="charts" class="chart-style"></div>
    </div>

    <div class="bottom">
      <div class="title-box">
        <span class="title-g"></span>
        <!-- <img src="/static/img/home/title.png" alt=""> -->
        <span>告警处理统计</span>
        <div class="date-box">
          <el-select v-model="date" @change="handleChange">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <ul class="list-box">
        <li v-for="(item, index) in list" :key="index">
          <span>{{ item.name }}</span>
          <div class="progress-box">
            <div class="progress">
              <p :style="{ width: item.per + '%'}"></p>
            </div>
            <span>{{ item.value }}</span>次
            <!-- <el-progress
              :percentage="item.value"
              :format="format"
              :stroke-width="10"
              color="#28F4D2"
            ></el-progress> -->
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import { formatDateTime } from '@/utils/objectUtil'
import { OPTIONBAR } from './../config/index.js'
import { getStatisWarnings, getStatisHandle } from '../service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'ContentInfo',
  props: {
    right: {
      type: Number,
      default: 20,
    },
  },

  data () {
    return {
      // type=0:本周、type=1:本月、type=2:本年
      date: 2,
      options: [
        { label: '本周', value: 0 },
        { label: '本月', value: 1 },
        { label: '本年', value: 2 },
      ],
      list: [
        // { name: '李世伟', value: 1555888886, per: 10 },
        // { name: '刘晓', value: 10, per: 20 },
        // { name: '王振鑫', value: 5, per: 30 },
        // { name: '常文博', value: 1, per: 0 },
      ],
      totalTimes: 100,
    }
  },
  computed: {
    ...mapGetters(['currentTab']),
  },

  created () {
  },
  mounted () {
    this.$nextTick(() => {
      this.initChart()
    })
    let params = { type: this.date, groupId: this.currentTab }
    this.getStatisHandle(params)
  },
  methods: {
    initChart () {
      let chartDom = this.$refs.charts
      this.chart = this.$echarts.init(chartDom)

      let option = JSON.parse(JSON.stringify(OPTIONBAR))
      this.chart.setOption(option)
      this.getStatisWarnings(option)
    },
    async getStatisWarnings (option) {
      let res = await getStatisWarnings({ groupId: this.currentTab })
      if (res.code === 'success') {
        let { list } = res.data
        let [xAxis, data1, data2] = [[], [], []]

        list && list.forEach(({ name, warnings, devices }) => {
          xAxis.push(name)
          data1.push(warnings)
          data2.push(devices)
        })
        option.xAxis.data = xAxis
        option.series[0].data = data1
        option.series[1].data = data2
        this.chart.setOption(option)
      }
    },
    async getStatisHandle (params) {
      let res = await getStatisHandle(params)
      if (res.code === 'success') {
        let { list } = res.data
        let temp = list && list.sort((a, b) => b.value - a.value)
        let max = 100

        temp && temp.length && (max = temp[0].value > 100 ? temp[0].value : 100)

        let tempList = list && list.map(({ name, value }) => ({ name, value, per: (value / max * 100) }))
        this.list = tempList
      }
    },
    /**
     * @description: 改变select时间段
     * @param        {} e [description]
     * @return       {[type]}   [description]
     */
    handleChange (e) {
      this.getStatisHandle({ type: e, groupId: this.currentTab })
    },
    format (per) {
      return `${per}次`
    },
  },
}
</script>

<style lang="less" scoped>
.right-box {
  position: absolute;
  top: 210px;
  right: 20px;
  z-index: 9;
  width: 340px;
  padding: 20px;
  background: url('/static/img/home/list-bg.png') no-repeat;
  background-size: 100% 100%;
  transition: 0.5s;
  .title-box {
    border-radius: 5px;
    background-image: linear-gradient(to right, #05496D, transparent);
    color: #12AEF1;
    height: 32px;
    line-height: 32px;
    font-size: 18px;
    font-weight: bold;
    font-style: italic;
    img {
      vertical-align: -6px;
      margin-right: 10px;
    }
    .title-g {
      display: inline-block;
      width: 0;
      height: 10px;
      border: 2px solid #12AEF1;
      margin-right: 10px;
    }
  }
  .top {
    .chart-style {
      // border: 1px solid red;
      height: 220px;
    }
  }
  .bottom {
    margin-top: 10px;
    .date-box {
      float: right;
      width: 80px;
      /deep/ .el-input__inner{
        background-color: transparent;
        color: #12aef1;
        height: 30px;
        border: 1px solid #12aef1;
      }
      /deep/ .el-input__icon{
        line-height: 30px;
      }
    }
    .list-box {
      // border: 1px solid red;
      margin-top: 20px;
      height: 140px;
      overflow: auto;
      li {
        // border: 1px solid red;
        margin-top: 10px;
        >span {
          display: inline-block;
          width: 70px;
          color: #fff;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 5px;
          text-align: right;
          vertical-align: middle;
        }
        .progress-box {
          display: inline-block;
          width: 258px;
          color: #ccc;
          font-size: 12px;
          .progress {
            display: inline-block;
            border: 1px solid #253E55;
            height: 12px;
            width: 180px;
            vertical-align: middle;
            border-radius: 12px;
            overflow: hidden;
            >p {
              width: 0%;
              height: 100%;
              background-color: #28F4D2;
              border-radius: 13px;
            }
          }
          span {
            vertical-align: middle;
            height: 20px;
            line-height: 20px;
            max-width: 52px;
            display: inline-block;
            margin-right: 3px;
            margin-left: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          // /deep/ .el-progress-bar__outer {
          //   background-color: transparent;
          //   border: 1px solid #253E55;
          // }
          // /deep/ .el-progress-bar {
          //   padding-right: 80px;
          //   margin-right: -80px;
          // }
          // /deep/ .el-progress__text {
          //   display: inline-block;
          //   width: 75px;
          //   overflow: hidden;
          //   text-overflow: ellipsis;
          //   white-space: nowrap;
          //   margin-left: 5px;
          //   color: #ccc;
          // }
        }
      }
    }
  }
}
</style>
